var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRoute = function SvgRoute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#route_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    d: "M7.665 3.333h.29c2.031 0 3.047 0 3.433.365.333.315.48.78.39 1.23-.103.52-.933 1.107-2.591 2.28l-2.71 1.917c-1.658 1.173-2.488 1.76-2.592 2.28-.09.45.058.915.391 1.23C4.662 13 5.678 13 7.71 13h.623m-3-9.667a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm9.333 9.334a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "route_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff"
  })))));
};
export default SvgRoute;